function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M80.1,59.5c13.5-10.3,31.3-13,47.2-7.2l4.5,1.6l16.3-23.6c0.5-0.8,1.6-0.9,2.4-0.4l11.4,8 c0.4,0.3,0.6,0.7,0.7,1.1c0.1,0.4,0,0.9-0.2,1.3l-16.4,23.7l3,3.7c10.5,13.2,13.9,30.7,9,46.8L80.1,59.5z M172.4,47.6 c4.5-6.5,2.9-15.4-3.5-19.9l-11.4-8.1c-6.4-4.5-15.2-3-19.7,3.4l-0.1,0.1L126.9,39c-25.5-7.1-52.8,2.8-67.8,24.6l-33,47.6 c-2,2.9-1.3,6.8,1.5,8.8c2.8,2,6.7,1.3,8.7-1.5c0,0,0,0,0-0.1l32.9-47.6c0.5-0.8,1.1-1.5,1.7-2.2l81.5,57.7 c-0.5,0.8-0.9,1.6-1.5,2.4l-28.4,41c-0.6,0.7-1.6,0.9-2.3,0.4l-47.8-33.8L85,118.3c4.5-6.5,2.9-15.4-3.5-20l-1.2-0.8 c-6.4-4.5-15.2-3-19.7,3.4l-0.1,0.1l-16,23.1c-2,2.9-1.3,6.8,1.5,8.8c2.8,2,6.7,1.3,8.6-1.5l0.1-0.1l16-23.1 c0.5-0.7,1.6-0.9,2.3-0.4l1.2,0.8c0.8,0.5,0.9,1.6,0.4,2.4l-19.6,28.3l58,41c3,2.2,6.9,3.1,10.6,2.4c3.7-0.6,7-2.7,9.2-5.8l28.4-41 c14.9-21.8,14.9-50.5,0-72.3L172.4,47.6L172.4,47.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.3a94e2a1e206612256f50143ee13b54c.svg";
export { ForwardRef as ReactComponent };